/**
 * Theme Toggle System - Dark/Light Mode
 * Controls theme switching with localStorage persistence
 */

class ThemeToggle {
    constructor() {
        this.currentTheme = localStorage.getItem('theme') || 'dark';
        this.toggleButtons = document.querySelectorAll('.theme-toggle');
        this.init();
    }

    init() {
        // Apply saved theme on page load
        this.applyTheme(this.currentTheme);

        // Set up event listeners for all toggle buttons
        this.toggleButtons.forEach(button => {
            button.addEventListener('click', () => this.toggle());
        });

        // Listen for system theme changes (optional)
        if (window.matchMedia) {
            window.matchMedia('(prefers-color-scheme: dark)').addListener(() => {
                // Only respond if user hasn't manually set a theme
                if (!localStorage.getItem('theme')) {
                    this.currentTheme = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
                    this.applyTheme(this.currentTheme);
                }
            });
        }
    }

    toggle() {
        this.currentTheme = this.currentTheme === 'dark' ? 'light' : 'dark';
        this.applyTheme(this.currentTheme);
        this.saveTheme();
    }

    applyTheme(theme) {
        const html = document.documentElement;

        // Set theme attribute
        html.setAttribute('data-theme', theme);

        // Control starfield visibility
        this.toggleStarfield(theme);

        // Update theme toggle icons (handled by CSS)
        this.updateAriaLabels(theme);

        console.log(`Theme switched to: ${theme}`);
    }

    toggleStarfield(theme) {
        const starfieldSection = document.querySelector('.starfield-section');
        if (starfieldSection) {
            // Always show the section, but change the canvas content based on theme
            starfieldSection.style.display = 'block';

            // Trigger canvas change based on theme
            if (theme === 'light') {
                // Light mode: topographic canvas will be handled by topographic-canvas.js
                console.log('Switching to light mode - topographic canvas');
            } else {
                // Dark mode: starfield canvas will be handled by starfield-canvas.js
                console.log('Switching to dark mode - starfield canvas');
            }
        }
    }

    updateAriaLabels(theme) {
        this.toggleButtons.forEach(button => {
            const newLabel = theme === 'dark'
                ? 'Cambiar a modo claro'
                : 'Cambiar a modo oscuro';
            button.setAttribute('aria-label', newLabel);
        });
    }

    saveTheme() {
        localStorage.setItem('theme', this.currentTheme);
    }

    getCurrentTheme() {
        return this.currentTheme;
    }
    attachListeners() {
        // Re-query buttons to ensure we have the latest DOM elements (post-Turbo render)
        this.toggleButtons = document.querySelectorAll('.theme-toggle');

        this.toggleButtons.forEach(button => {
            // Remove old listeners to be safe (though cloning or fresh query usually handles this)
            // Ideally we'd use a named function to remove, but here we just ensure we are fresh
            const newButton = button.cloneNode(true);
            button.parentNode.replaceChild(newButton, button);

            newButton.addEventListener('click', (e) => {
                e.preventDefault(); // Prevent any default anchor behavior
                this.toggle();
            });

            // Re-update the reference in our list so future Aria updates work
            // (Actually, better to just rely on re-querying or just update the new button now)
        });

        // Refresh the list reference after cloning replacement
        this.toggleButtons = document.querySelectorAll('.theme-toggle');
    }
}

// Initialize theme toggle when DOM is ready or Turbo navigates
const initThemeToggle = () => {
    if (!window.themeToggle) {
        window.themeToggle = new ThemeToggle();
    }

    // ALWAYS re-bind listeners and update state, because Turbo replaces the Body
    // effectively destroying our previous button elements.
    window.themeToggle.attachListeners();
    window.themeToggle.applyTheme(window.themeToggle.getCurrentTheme());
};

document.addEventListener('DOMContentLoaded', initThemeToggle);
document.addEventListener('turbo:load', initThemeToggle);
document.addEventListener('turbo:render', initThemeToggle);
// We might not need frame-render if the header isn't inside a frame, 
// but if it is, this ensures it works.
document.addEventListener('turbo:frame-render', initThemeToggle);

// Immediate theme application (prevent flash)
(function () {
    const savedTheme = localStorage.getItem('theme') || 'dark';
    document.documentElement.setAttribute('data-theme', savedTheme);
})();